import React from 'react';
import { DialogActions, Button } from '@mui/material';
import { EditDialogActionsProps } from '../shared/types';

const EditDialogActions: React.FC<EditDialogActionsProps> = ({ onClose, onSave, isSaving }) => (
  <DialogActions sx={{ padding: '16px 24px', justifyContent: 'flex-end', gap: '12px' }}>
    <Button onClick={onClose} variant="outlined" disabled={isSaving}>
      Cancel
    </Button>
    <Button onClick={onSave} variant="contained" color="primary" disabled={isSaving}>
      {isSaving ? 'Saving...' : 'Save'}
    </Button>
  </DialogActions>
);

export default EditDialogActions;
